import { Dialog, Button } from "@mui/material";
import React from "react";

import { ReactComponent as TipIcon } from "assets/tip.svg";
import { ReactComponent as XMark } from "assets/x-mark.svg";

import styles from "./EditMode.module.scss";

type Props = {
  showWarning: boolean;
  setShowWarning: (showWarning: boolean) => void;
  onExit: () => void;
};

const TrackingAreaWarning = ({
  showWarning,
  setShowWarning,
  onExit,
}: Props) => {
  return (
    <Dialog
      open={showWarning}
      slotProps={{
        paper: {
          className: "dialog",
        },
      }}
    >
      <div className="modalContainer">
        <div className="modalHeader">
          <h3 className="modalTitle">Warning: Selected area too small</h3>
          <button
            onClick={() => {
              setShowWarning(false);
            }}
            type="button"
            className="closeButton"
          >
            <XMark />
          </button>
        </div>
        <div className={styles.confirmationText}>
          <p>
            Camera tracking works best when you cover the maximum amount of the
            trackable background. Would you like to update your selection on
            this keyframe?
          </p>

          <div className={styles.tip}>
            <TipIcon />
            <div>
              <a
                href="https://support.slapshot.ai/en/support/how-do-i-create-3d-tracks-with-ai-in-slapshot"
                target="_blank"
                rel="noreferrer"
              >
                Click here
              </a>{" "}
              to view our camera tracking tutorial.
            </div>
          </div>
        </div>
        <div className="modalActions">
          <Button
            type="button"
            className={styles.noBackgroundButton}
            onClick={() => {
              setShowWarning(false);
            }}
          >
            Keep selecting
          </Button>
          <Button
            type="button"
            className={styles.outlineButtonRed}
            onClick={(e) => {
              e.stopPropagation();
              onExit();
            }}
          >
            Save and Proceed
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default TrackingAreaWarning;
